import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import * as fromRoot from '@app/reducers';
import { pageAnimation } from '@app/shared/animations/page-animations';
import { Device } from '@app/shared/models/device';
import { TransferFile } from '@app/shared/models/transferFile';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ViewerActions } from '../actions';
import * as fromViewer from '../reducers/viewer.reducer';
import { environment } from 'src/environments/environment';
import { GetTransferPreviewOutput } from '@smash-sdk/transfer/ejs/01-2024';

export enum KEY_CODE {
  ESCAPE = 27,
}
@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  animations: [
    pageAnimation
  ]
})
export class PreviewComponent implements OnInit {

  @Input() preview: GetTransferPreviewOutput;
  @Input() device: Device;
  @Input() files: TransferFile[];
  @Input() selectedFiles: TransferFile[];
  @Input() snackbarDisplayed: boolean;

  @Output() unscrollPreview: EventEmitter<boolean> = new EventEmitter<boolean>();
  hostname = environment.appDomainWithProtocol;
  selectedModalFile$: Observable<TransferFile>;
  hideButton = false;

  constructor(private store$: Store<fromRoot.State & fromViewer.State>) {
    this.selectedModalFile$ = this.store$.select(fromViewer.getSelectedModalFile);
  }

  ngOnInit(): void { }

  unscroll() {
    this.unscrollPreview.emit(true);
  }

  downloadZip() {
    this.store$.dispatch(ViewerActions.RequestDownloadUrls({}));
  }

  onVideoPlaying($event) {
    this.hideButton = $event;
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === KEY_CODE.ESCAPE) {
      this.unscroll();
    }
  }
}
